import SEOLandingTemplate from './SEOLandingTemplate';

export default function SitemapGeneratorPage() {
  return (
    <SEOLandingTemplate
      title="XML Sitemap Generator"
      metaTitle="Free XML Sitemap Generator | Sungresh"
      metaDescription="Crawl a website and generate an XML sitemap ready to submit to Google Search Console."
      h1="Free XML Sitemap Generator"
      sub="Crawl a site and generate a sitemap.xml file with URLs, last-modified dates, and priority hints — ready to upload and submit to Search Console."
      keywords="xml sitemap generator, sitemap generator, create sitemap"
      ctaLink="/audit/site"
      ctaText="Generate a Sitemap Free"
      features={[
        { icon: '🕷️', title: 'Site Crawl', desc: 'Discovers internal URLs by crawling your site' },
        { icon: '🗺️', title: 'Standard XML', desc: 'Outputs a sitemap.xml file in the format search engines expect' },
        { icon: '📅', title: 'Last-Modified Dates', desc: 'Included automatically where available' },
      ]}
      faqs={[
        { q: 'Do I actually need a sitemap?', a: 'It helps search engines discover your pages faster, especially on larger sites or ones with pages that aren\'t well linked internally. It\'s a strong nice-to-have rather than an absolute requirement for small, well-linked sites.' },
        { q: 'Where do I put the sitemap file?', a: 'Upload it to your domain root — yoursite.com/sitemap.xml — then submit that URL under the Sitemaps section of Google Search Console.' },
        { q: 'Is there a size limit?', a: 'The sitemap protocol caps a single file at 50,000 URLs or 50MB uncompressed. Larger sites use a sitemap index file referencing multiple smaller sitemaps.' },
      ]}
    />
  );
}
